import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ImpactMapPage } from './impact-map.page';

const routes: Routes = [
  {
    path: '',
    component: ImpactMapPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ImpactMapPageRoutingModule {}
